import type { ICheckoutContext } from '@/types/context';
import { PaymentMethodEnum } from '@/types/common';
import { createVenmoPaymentPayload } from '@/utils/venmo';
import type { VenmoPaymentResponse } from '@/types/venmo';
import type { VenmoPaymentParams } from '@/types/paymentHandlers';
import { Errors } from '@/constants/errors';

export const handleVenmoPayment = async (
  checkout: ICheckoutContext,
  sendPaymentToServer: (params: unknown) => Promise<unknown>,
  params?: VenmoPaymentParams
): Promise<VenmoPaymentResponse> => {
  if (!params?.nonce) {
    throw new Error(Errors.payment.paymentFailed);
  }

  const paymentMethodSettings = checkout.paymentMethodsSettings.find(
    (pm) => pm.paymentMethodName === PaymentMethodEnum.VENMO
  );

  if (!paymentMethodSettings) {
    throw new Error('Venmo payment method settings not found');
  }

  const payload = createVenmoPaymentPayload({
    provider: paymentMethodSettings.provider,
    email: checkout.customer.email ?? '',
    paymentMethodDisplayName: paymentMethodSettings.paymentMethodName,
    paymentMethodId: paymentMethodSettings.id,
    nonce: params.nonce,
    deviceData: params.deviceData,
  });

  return (await sendPaymentToServer(payload)) as VenmoPaymentResponse;
};
